<template>
    <div name="login" class="wrapper">
        <div class="page" v-if="isView">
 
        </div>
    </div>
</template>

<script>
import Constant from '@/constant';

export default {
    name: 'login',
    data: function()
    {
        return {
            isView: false,
            ref: null
        }
    },
    mounted: async function()
    {
        // this.returnUrl = this.$route.query.return_url;

        if(this.$route.query.kakao)
        { 
            this.isView = false;
            this.afterLogin(this.$route.query.kakao);
        }
        else
        {
            // 첫페이지 진입 view_landing
            // this.isView = true;
            this.login();
        }

    },
    methods: {    
        sendEvent: function(eventName)
        {
            if(this.ref !== null)
            {
                const nowSeconds = Math.floor(Date.now() / 1000);
                this.$store.dispatch(Constant.SEND_EVENT_CODE, {eventName: eventName, eventCode: this.ref, time: nowSeconds})
                    .then((response) => {

                    })
                    .then(() => {

                    })
            }
        },
        login: function()
        {
            //카카오 로그인 버튼 클릭 click_login_kakao
            const REST_API_KEY = process.env.KAKAO_REST_API_KEY;
            const REDIRECT_URI = process.env.KAKAO_REDIRECT_URI;
            let STATE = `${process.env.LOGIN_URI}/anzeilax` + `${this.ref ? `?ref=${this.ref}` : '' }`;
            window.location.href = `https://kauth.kakao.com/oauth/authorize?client_id=${REST_API_KEY}&redirect_uri=${REDIRECT_URI}&response_type=code&prompt=login&state=${STATE}`;
        },
        afterLogin: function(kakaoId)
        {
            // 로그인 완료 complete_login_kakao
            this.$store.dispatch(Constant.AUTH_INAPP, {type: 'ANZEILAX', id: kakaoId})
                .then((response) => {
                    window.location.href = response; 
                })
                .catch((err) => {

                })
        },
        
    }


}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        height: 100dvh;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow-y: hidden;
    }
    .banner {
        width: calc(100%);
        display: flex;
        justify-content: center;
        box-sizing: border-box;
        height: 50%;
        max-height: 400px;
        background-image: url('../../assets/sleepq/sleepq_banner.png');
        background-size: contain;       /* 이미지 전체가 보이도록 */
        background-position: center;
        background-repeat: no-repeat;      /* 3:1 비율 유지 (예시) */
    }
    .page {
        width: 100%;
        height: 100%; /* 화면 전체 높이 */
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        box-sizing: border-box;
        padding-top: 32px;
        padding-bottom: 32px;
        overflow-y: hidden;
    }
    .row {
        display: flex;
        flex-direction: column;
        width: 100%;
        justify-content: center;
        align-items: center;
        padding: 0 16px;
        box-sizing: border-box;
    }
     .header-title {
        color: #1A1B1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        text-align: center;
        line-height: 150%;
    }
    .title {
        color: #1A1B1E;
        font-family: Pretendard;
        font-size: 27.34px;
        font-style: normal;
        font-weight: 700;
        line-height: 144%;
    }
    .kakao-button {
        width: 100%;
        display: flex;
        height: 55px;
        border-radius: 6px;
        background: #FFE601;
        justify-content: center;
        align-items: center;
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        position: relative;
        cursor: pointer;
    }
    .kakao-button-icon {
        margin-right: 8px;
        width: 24px;
    }
   
    .line {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .description {
        color: #1A1B1E;
        font-family: Pretendard;
        font-weight: 500;
        font-size: 14px;
        line-height: 144%;
    }
    .small {
        color: #6E717D;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        margin-top: 20px;
    }

    @media (min-width: 600px) {
        .page {
            width: 600px;
            height: 1298px;
        }
    }
    @media (min-height: 580px) {
       .title {
            color: #1A1B1E;
            font-family: Pretendard;
            font-size: 28px;
            font-style: normal;
            font-weight: 700;
        }

    }

    .dots-over{
        position: relative;
        display: inline-block;
        line-height: 1;            /* 점 위치 계산 안정화 */
        color: #3651B2;
    }

        /* 점 3개 */
    .dots-over::before{
        --dot: 0.15em;             /* 점 크기 (글자 크기에 비례) */
        content: "";
        position: absolute;
        left: 50%;
        top: calc(-0.31em);           /* 글자 위 간격 (원하면 조절) */
        width: var(--dot);
        height: var(--dot);
        background: currentColor;  /* 글자색과 동일 */
        border-radius: 50%;
        transform: translateX(-50%);
        /* 좌우로 복제해서 총 3개로 보이게 */
        box-shadow:
            calc(-1em) 0 0 currentColor,
            calc( 1em) 0 0 currentColor;
        }
</style>


// WEBPACK FOOTER //
// src/page/anzeilax/index.vue